/* 引入 Inter 字体 */
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

/* 基础样式重置 */
:root {
  font-family: 'Inter', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  line-height: 1.5;
  font-weight: 400;
  color-scheme: light;
  font-synthesis: none;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  margin: 0;
  display: flex;
  min-width: 320px;
  min-height: 100vh;
  background-color: #f8fafc;
}

#root {
  width: 100%;
}

/* 基础元素样式 */
button {
  border-radius: 6px;
  border: 1px solid transparent;
  padding: 0.5em 1em;
  font-size: 1em;
  font-weight: 500;
  font-family: inherit;
  background-color: transparent;
  cursor: pointer;
  transition: all 0.15s ease-out;
}

button:focus,
button:focus-visible {
  outline: none;
}

/* 响应式基础 */
@media (max-width: 768px) {
  body {
    font-size: 14px;
    min-width: 320px;
    overflow-x: hidden;
  }

  #root {
    min-width: 320px;
    overflow-x: hidden;
  }
}

/* 防止移动端双击缩放 */
* {
  touch-action: manipulation;
}

/* 移动端触摸反馈 */
@media (hover: none) {
  button:active,
  .style-card:active,
  .palette-card:active,
  .platform-card:active {
    transform: scale(0.98);
    opacity: 0.9;
  }
}
